import * as React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "../../layout";
import { OrgList } from "./orgList";
import { AccountList } from "./accountList";
import { FirebaseUserProfile } from "../firebaseUser/firebaseUser";
import { HomeMain } from "./main";
import { AccountCreate } from "../account/create/create";
import { OrgCreateForm } from "../org/create";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { selectHasAccount } from "../../store/userDataSlice";
import { BillingAccountDetailInitializer } from "../account/detailInitializer";

export const HomeRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);
  const hasAccount = useAppSelector(selectHasAccount);
  const { pathname } = useLocation();

  // Stabilize key during account creation to prevent Layout remount when org changes
  // (createOrgGVC dispatches setOrg which would change key={org} and destroy the form)
  const layoutKey = pathname.includes("/account/-create") ? "account-create" : org;

  return (
    <Layout key={layoutKey} showLeftMenu={hasAccount}>
      <Routes>
        <Route index element={<HomeMain />} />
        <Route path={`org/-create/*`} element={<OrgCreateForm />} />
        <Route path={`org`} element={<OrgList />} />
        <Route path={`account/-create/*`} element={<AccountCreate />} />
        <Route path={`account/:id/*`} element={<BillingAccountDetailInitializer />} />
        <Route path={`account`} element={<AccountList />} />
        <Route path={`profile`} element={<FirebaseUserProfile />} />
      </Routes>
    </Layout>
  );
};

// referral service integration

// on account creation
//   inform external id if found, if not, inform by cookie

// hubspot
//   call hubspot service /addpaymentmethod after payment method is added

// disabled account cannot see org gvc step

// clear after processing
// localStorage.setItem(STORAGE_KEY_ACCOUNT_EXTERNAL_ID, id);
